export enum RouterPath {
  CHOOSE_DESK = `chooseDesk`,
  CHOOSE_ORGANIZATION = `chooseOrganization`,
  CONVERSATIONS = `conversations`,
  KNOWLEDGE_BASE = `knowledgeBase`,
  KNOWLEDGE_BASE_ARTICLE = `knowledgeBaseArticle`,
  KNOWLEDGE_BASE_CATEGORY = `knowledgeBaseCategory`,
  KNOWLEDGE_BASE_SUB_CATEGORY = `knowledgeBaseSubCategory`,
  MESSAGES = `messages`,
  MORE = `more`,
  NO_APPLICATIONS = `noApplications`,
  PAGE_NOT_FOUND = `pageNotFound`,
  REGISTER = `register`,
  REQUIREMENT = `requirement`,
  REQUIREMENTS = `requirements`,
  RESET_PASSWORD = `reset-password`,
  SEARCH_ALL = `searchAll`,
  SETTING_APPEARANCE = `settingAppearance`,
  SETTING_NOTIFICATIONS = `settingNotifications`,
  SETTING_PROFILE = `settingProfile`,
  SIGN_IN = `signIn`,
  SIGN_UP = `signUp`,
  TASK = `task`,
  TASKS = `tasks`,
  TICKET = `ticket`,
  TICKETS = `tickets`,
  TIME_SHEET = `timeSheet`,
  TIME_SHEETS = `timeSheets`,
  TIMER = `timer`,
  UNIVERSAL_LINK = `universalLink`,
  WEB_FORM = `webForm`,
  WEB_FORMS = `webForms`,
  WEB_PAGES = `webPages`,
  WELCOME = `welcome`,
  WORK_ITEM_CUSTOM_FIVE = `wi-c5`,
  WORK_ITEM_CUSTOM_FOUR = `wi-c4`,
  WORK_ITEM_CUSTOMS_FIVE = `wi-cs5`,
  WORK_ITEM_CUSTOMS_FOUR = `wi-cs4`
}
